import { useState } from "react";
import InputText from "../../../../../components/InputText";
import ModalReportStyles from "../../../../../styles/pages/Summaries/ModalReportStyles";
import { IList } from "../../../../../context/interfaces/IFilterDataContext";

const { StyledSearchInput } = ModalReportStyles;

interface IFilterSelectData {
    keyName: string;
    referenceList: IList[];
    setSearchList: (arg0: IList[]) => void;
}

const FilterSelectData: React.FC<IFilterSelectData> = ({
    keyName,
    referenceList,
    setSearchList,
}) => {
    const [searchText, setSearchText] = useState<string>("");

    const handleFilterBySearch = (value: string) => {
        if (!value.length) return setSearchList(referenceList);

        const filteredData = referenceList.filter(
            (item) =>
                item.name.toUpperCase().includes(value.toUpperCase()) ||
                item.description.toUpperCase().includes(value.toUpperCase())
        );
        return setSearchList(filteredData);
    };

    const handleSearchFilter = (event: any) => {
        const { value } = event.target;
        setSearchText(value);
        handleFilterBySearch(value);
    };

    return (
        <StyledSearchInput>
            <InputText
                value={searchText}
                placeholder={`Pesquisar por ${keyName}`}
                onChange={(e) => handleSearchFilter(e)}
            />
        </StyledSearchInput>
    );
};

export default FilterSelectData;
